/* Parsing for the jukebox's tiny text notation (kept DOM-free so it's testable). */

const LETTER: Record<string, number> = { C: 0, D: 2, E: 4, F: 5, G: 7, A: 9, B: 11 };

/** "C5" → 72, "F#4" → 66, "Bb3" → 58. Returns null for anything else. */
export function noteToMidi(token: string): number | null {
  const m = /^([A-G])(#|b)?(-?\d)$/.exec(token);
  if (!m) return null;
  const [, letter, acc, octave] = m;
  const base = LETTER[letter ?? ''];
  if (base === undefined) return null;
  const shift = acc === '#' ? 1 : acc === 'b' ? -1 : 0;
  return base + shift + (Number(octave) + 1) * 12;
}

/** "Am" → [57, 60, 64]; "G7" → [55, 59, 62, 65]. Voiced around octave 3–4. */
export function chordToMidi(token: string): number[] | null {
  const m = /^([A-G])(#|b)?(m|7|maj7|m7)?$/.exec(token);
  if (!m) return null;
  const [, letter, acc, quality] = m;
  const base = LETTER[letter ?? ''];
  if (base === undefined) return null;
  const root = 57 + ((base + (acc === '#' ? 1 : acc === 'b' ? -1 : 0) - 9 + 12) % 12);
  const third = quality === 'm' || quality === 'm7' ? 3 : 4;
  const notes = [root, root + third, root + 7];
  if (quality === '7' || quality === 'm7') notes.push(root + 10);
  if (quality === 'maj7') notes.push(root + 11);
  return notes;
}

/** Split a track into per-step tokens, ignoring bar lines. */
export function tokens(track: string): string[] {
  return track.split(/\s+/).filter((t) => t.length > 0 && t !== '|');
}

/** Bars (16 steps each) for validation. */
export function bars(track: string): string[][] {
  return track.split('|').map((bar) => bar.split(/\s+/).filter(Boolean));
}

/** Number of steps a note sounds for, counting following `-` holds. */
export function heldSteps(stream: readonly string[], index: number): number {
  let n = 1;
  for (let i = index + 1; i < stream.length && stream[i] === '-'; i++) n++;
  return n;
}
